let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ibVcz")).then(() => parcelRequire('4vzBZ'));